module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    class: {
      focus: _vm.type == 0, splash: _vm.type == 1
    },
    on: {
      "click": function($event) {
        _vm.click()
      }
    }
  }, [_h('h1', ["广告" + _vm._s(_vm.type + 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11b12d06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11b12d06!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/temp/2017-01-05.vue
// module id = 38
// module chunks = 0